import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useMediaQuery } from "react-responsive";
import { FunctionalButton } from "components/functionalButton";
import { MultilineTextField} from 'components/multilineTextField';

import {
  StyledQuestion,
  InfoArea,
  StyledAddressContainer,
  // StyledSkipText,
  // TextContainer
 } from './styles';
 
 import Input from '../../../../components/inputField';
export const ProjectLocation = ({
  handleNext,
  data,
  setData,
  panel,
  setPanel,
  setIsLastPanel,
  setPreviousStepPanel
}) => {
  const isMobile = useMediaQuery({ maxWidth: 960 });
  setIsLastPanel(true);
  setData('additional_document', []);
  // console.log(data);
  return (
    <>
      <StyledQuestion isMobile={isMobile} width="650px">Who is the Project Owner?</StyledQuestion>
      <InfoArea isMobile={isMobile} width="650px" isColumn={true} marginTop="0px">
        <Input
          label="City"
          type="text"
          labelSize="12px"
          fontSize="18px"
          marginTop="16px"
          // value={prequalifyData?.project_info?.owner_name}
          // setValue={(e) => setPrequalifyData('project_info.owner_name', e)}
        />
      </InfoArea>
      <InfoArea isMobile={isMobile} width="650px" isColumn={true} marginTop="0px">
      <StyledAddressContainer>
        <Input
          label="Province/State"
          type="text"
          labelSize="12px"
          fontSize="18px"
          // value={prequalifyData?.project_info?.owner_email}
          marginTop="16px"
          // setValue={(e) => setPrequalifyData('project_info.owner_email', e)}
        />
      
        <Input
          label="Phone Number"
          type="text"
          labelSize="12px"
          fontSize="18px"
          marginTop="16px"
          // value={prequalifyData?.project_info?.owner_phone}
          // setValue={(e) => setPrequalifyData('project_info.owner_phone', e)}
        />
      </StyledAddressContainer>
      </InfoArea>
      <InfoArea>
        <MultilineTextField width={'650px'}placeholder="Write a detailed Description" row={5}/>  
      </InfoArea>
      <FunctionalButton
          buttonTitle="Next"
          handleButton={() => handleNext()}
          width="200px"
          marginRight="0px"
          marginTop="48px"
        />
    </>
  );
}
